import React from 'react';
import {AbstractMapItem, MapInput} from '../MapItems/MapItems';
import './WDRIconItem.css';
import {updateTempColor} from './temps';

export function WDRIconItem(props) {
  const item = props.item;
  const temperature = Object.keys(item.data)[0];
  const icon = Object.keys(item.data)[1];

  function updateIcon(iconIndex) {
    return 'url("images/wdr/icons/wdr_' + iconIndex + '.gif")';
  }

  function createDangerIcon(isDanger) {
    if (isDanger) {
      return (
        <div
          className='danger-icon'
          style={{backgroundImage: item.ui.dangerIcon}}></div>
      );
    }
  }
  return (
    <AbstractMapItem {...props}>
      <div
        className='wdr-icon-item'
        style={{
          backgroundColor: updateTempColor(item.data.temperature.value),
          backgroundImage: item.ui.backgroundImage
        }}>
        {/* CREATE TEMP BOX */}
        <div className='map-item-input-wdr-temp-input-wrapper'>
          {/* <input className="temp-input"

                        name="temperature"
                        onChange={(e) => props.onChange(item, { temperature: { value: e.target.value } })}
                        value={item.data.temperature.value}
                    /> */}
          <MapInput
            item={item}
            data={{key: temperature, value: item.data[temperature].value}}
            callback={props.setValueInMap}
          />
        </div>
        {/* CREATE ICON BOX */}
        <div
          className='map-item-input-wdr-icon-input-wrapper'
          style={{
            backgroundImage: updateIcon(item.data.icon.value)
          }}>
          <MapInput
            item={item}
            data={{key: icon, value: item.data[icon].value}}
            callback={props.setValueInMap}
          />
        </div>

        {createDangerIcon(item.data.isDanger.value)}

        <div className='danger-checkbox'>
          <input
            type='checkbox'
            checked={item.data.isDanger.value}
            onKeyPress={e => {
              if (e.key === 'Enter' || e.keyCode === 13) {
                props.setValueInMap(item, {
                  isDanger: {value: !e.target.checked}
                });
              }
            }}
            onChange={e =>
              props.setValueInMap(item, {isDanger: {value: e.target.checked}})
            }
          />
        </div>
      </div>
    </AbstractMapItem>
  );
}
